import { fromJS } from 'immutable';
import { normalizeEntities } from 'helpers/utilHelpers';

import { LOAD_WORKSPACES_SUCCESS } from 'constants/ActionTypes';

const initialState = fromJS({
  workspaces: {},
});

export default (state = initialState, action) => {
  if (action.type === LOAD_WORKSPACES_SUCCESS) {
    return state.set('workspaces', normalizeEntities(action.values.items, 'userId', state.get('workspaces')));
  }

  return state;
};
